/* eslint-disable no-underscore-dangle */
import Node from '~/scripts/services/model/node';
import Card from '~/scripts/services/model/card';

// noinspection JSClosureCompilerSyntax
/**
 * State class for Workflow Designer
 *
 * @augments Node
 */
export default class State extends Node {
	/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
	#oldkid;

	/* @ngInject */
	/**
	 * Instantiates a State
	 *
	 * @param {import('angular').auto.IInjectorService} $injector Injector dependency
	 * @param {import('@knitiv/api-client-javascript').KNode | undefined} [kid] Optional kid of the state
	 */
	constructor($injector, kid = undefined) {
		super($injector, kid, 'K_NODE;WF_STATE');

		this.#oldkid = undefined;

		/** @type {boolean} */
		this.affectAuto = false;

		/** @type {import('@knitiv/api-client-javascript').KNode[]} */
		this.allocators = [];

		/** @type {string} */
		this.color = '#000000';

		/** @type {import('@knitiv/api-client-javascript').KNode[]} */
		this.delegationGranted = [];

		/** @type {string | undefined} */
		this.id = undefined;

		/** @type {number} */
		this.initial = 0;

		this.kndef.KWF = {
			validate: {
				min: 1,
				max: 1,
			},
			mode: 'FIRST',
		};

		/** @type {any} */
		this.kjson = null;

		/** @type {boolean} */
		this.notify = true;

		/** @type {boolean} */
		this.notifyInitiator = false;

		/** @type {import('~/scripts/services/model/card').default} */
		this._observCard = new Card(0, 0);

		/** @type {boolean} */
		this.selected = false;

		/** @type {'RECTANGLE' | 'ROUNDRECT' | 'ELLIPSIS' | 'CIRCLE'} */
		this.shape = 'RECTANGLE';

		/** @type {boolean} */
		this.visible = true;

		/** @type {number | undefined} */
		this.x = undefined;

		/** @type {number | undefined} */
		this.y = undefined;
	}

	/**
	 * Adds an allocator to the state
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} allocator KID of the role
	 * @returns {number} index of the new allocator
	 */
	addAllocator(allocator) {
		if (this.allocators.includes(allocator)) {
			throw new Error('Ce rôle/profil est déjà dans la liste');
		}
		return this.allocators.push(allocator) - 1;
	}

	/**
	 * Adds an delegation granted profile to the state
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} delegationGranted KID of the profile
	 * @returns {number} index of the new delegation granted profile
	 */
	addDelegationGranted(delegationGranted) {
		if (this.delegationGranted.includes(delegationGranted)) {
			throw new Error('Ce profil est déjà dans la liste');
		}
		return this.delegationGranted.push(delegationGranted) - 1;
	}

	/**
	 * Checks if an allocator exists
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} allocator KID of the allocator
	 * @returns {number|boolean} True if exists
	 */
	allocatorExists(allocator) {
		const key = this.allocators.indexOf(allocator);
		return key >= 0 ? key : false;
	}

	/**
	 * Deletes an allocator from the state
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} allocator KID of the role
	 * @private
	 */
	deleteAllocator(allocator) {
		let index = this.allocators.length - 1;
		while (index >= 0) {
			if (this.allocators[index] === allocator) {
				this.allocators.splice(index, 1);
			}
			index -= 1;
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	setKid(kid) {
		this.#oldkid = kid;
		this.kid = kid;
	}

	get observCard() {
		return this._observCard;
	}

	/**
	 * @param {any} card
	 */
	set observCard(card) {
		this._observCard = typeof card === 'string' ? new Card(card) : card;
	}
}
